import { render, staticRenderFns } from "./getInsuranceDetail.vue?vue&type=template&id=4e8be2ab&scoped=true&"
import script from "./getInsuranceDetail.vue?vue&type=script&lang=js&"
export * from "./getInsuranceDetail.vue?vue&type=script&lang=js&"
import style0 from "./getInsuranceDetail.vue?vue&type=style&index=0&id=4e8be2ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8be2ab",
  null
  
)

export default component.exports